import React from "react";
import "./HomeStyles.css";
import Navbar from "../components/Navbar";
import InitialImg from "../components/InitialImg";
import ScrollRevealText from "../components/ScrollRevealText";
import SectionHeading from "../components/SectionHeading";
import AboutContent from "../components/AboutContent";
import FeaturedProjects from "../components/FeaturedProjects";
import Form from "../components/Form";
import Footer from "../components/Footer";
import projects from "../data/projects";

const Home = () => {
    return (
        <div>
            <Navbar />

            <section id="inicio">
                <InitialImg />
            </section>

            <section className="intro-statement">
                <ScrollRevealText text="Cero vueltas: te escucho, armamos un plan claro, y no freno hasta que funcione." />
            </section>

            <section id="sobre-mi">
                <SectionHeading
                    eyebrow="Sobre mí"
                    title="Desarrollador full-stack, cercano y resolutivo"
                />
                <AboutContent />
            </section>

            <section id="proyectos">
                <SectionHeading
                    eyebrow="Proyectos"
                    title="Algunos trabajos recientes, de punta a punta"
                />
                <FeaturedProjects projects={projects} />
            </section>

            <section id="contacto">
                <SectionHeading
                    eyebrow="Contacto"
                    title="Hablemos"
                    text="Contame en qué estás trabajando y lo vemos juntos"
                />
                <Form />
            </section>

            <Footer />
        </div>
    );
};

export default Home;
